'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIAlert from '@mui/material/Alert'
import { Link } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { LightbulbIcon } from '@repo/ui/LightbulbIcon'
import { Fragment } from 'react'

export const WizardPrompt = ({ wizardId = 'NewClient', screenFunction = 'create a new matter' }) => {
  const theme = useTheme()
  const prompts = []

  if (!wizardId.includes('NewClient'))
    prompts.push({
      text: 'create a new client',
      link: '?wizard=NewClient-NewMatter&stage=client&step=client-details'
    })

  if (!wizardId.includes('COIS'))
    prompts.push({
      text: 'perform a conflict of interest search',
      link: '?wizard=COIS-NewClient-NewMatter&stage=conflict&step=introduction'
    })

  if (!prompts.length) return null

  return (
    <MUIAlert data-testid="WizardPrompt" severity="info" sx={{ mb: 6, width: '100%' }} icon={<LightbulbIcon />}>
      <MUITypography variant="h5" sx={{ mb: 0, color: 'succes.dark' }}>
        Tip
      </MUITypography>
      <MUITypography variant="body1" sx={{ mb: 0, color: 'succes.dark' }}>
        This screen will let you <strong>{screenFunction}</strong>. You might prefer to{' '}
        {prompts.map(({ text, link }, index) => (
          <Fragment key={text}>
            <Link to={link} style={{ color: theme?.palette?.secondary?.dark || 'black' }}>
              {text}
            </Link>
            {index !== prompts.length - 1 ? ' or ' : ''}
          </Fragment>
        ))}
      </MUITypography>
    </MUIAlert>
  )
}

WizardPrompt.propTypes = {
  wizardId: PropTypes.string,
  screenFunction: PropTypes.string
}
